import axios from 'axios';
import { BuildAxiosClientErrorDetail } from './utilities';

const apiSentryDynamicsArcGIS = axios.create({
  baseURL: "https://test.sentrydynamics.net/sdarcgis/rest/services/"
});

apiSentryDynamicsArcGIS.interceptors.response.use(
    response => {
        // Return a successful response back to the calling service
        return response;
    },
    error => {
        if (error.response.status !== 0 && !error.config.noErrorHandling) {
            const selectedBrand = JSON.parse(localStorage.getItem("selectedBrand"));
            const errObj = { ...BuildAxiosClientErrorDetail(error), brand: selectedBrand };

            return apiSentryDynamicsArcGIS.post(`/log-error`, errObj, { noErrorHandling: true })
                .finally(() => {
                    window.location.href = '/oops';
                });
        }
        return new Promise((resolve, reject) => {
            reject(error.response);
        });
    }
);

export default apiSentryDynamicsArcGIS;